<template>
  <div class="export-wrap">
    <el-dropdown
      split-button
      type="sc-asset"
      size="small"
      trigger="click"
      :disabled="
        loader
      "
      @click="
        () => handleExport()
      "
      @command="
        handleExport
      ">
      <i class="el-icon-download"></i>
      ดาวน์โหลด
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :command="
            true
          ">
          ดาวน์โหลด (Incentive)
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script lang="js">

// Libs
import { DateTime } from 'luxon'

// Client
import { SubscriberReportClient as Client } from '@/clients/BackendAdminClient/subscriber-report'

export default {
  props: {
    filter: {
      type    : Object,
      required: true
    },
    loader: {
      type   : Boolean,
      default: false
    },
  },
  methods: {
    async handleExport(incentiveflag = false) {

      try {

        // Exporting
        this.$emit('update:loader', true)

        // Request Report Export
        const file = await Client.export({
          ...this.filter, incentiveflag
        })

        // File name
        const date = (
          DateTime.now().toFormat('yyyyMMdd')
        )

        // Download Link
        const link = document.createElement('a')

        // Set file
        link.href = URL.createObjectURL(
          new Blob([file])
        )

        // Set filename
        link.download = incentiveflag
          ? `subscriber-report-incentive-${date}.xlsx`
          : `subscriber-report-${date}.xlsx`

        // Trigger Download
        link.click()

        // Release Object URL
        URL.revokeObjectURL(link.href)
      }
      catch (error) {
        this.$emit(
          'error', error, 'ไม่สามารถดาวน์โหลดรายงานได้'
        )
      }
      finally {
        this.$emit(
          'update:loader', false
        )
      }
    }
  }
}
</script>
